module.exports = __webpack_public_path__ + "static/media/close.20733b52.svg";